<template>
  <div class="commonLiStyle">
    <top-component></top-component>
    <!-- <div class="bannerFirst" @click="ComeLive"></div> -->
    <div class="commonLiContainer">
      <MyAside></MyAside>
      <div class="commontent">
        <div class="titleMap">田田阅读电子书</div>
        <div class="letterTitle">2020/4/12    23:00</div>
        <div class="twodiv">
          网站账号开通及试用可联系我们公司驻当地分公司业务人员
        </div>
        <div class="twodiv link" @click="toLogin('http://www.ytzhihui.com/platformweb/index.html')">
          <span> www.ytzhihui.com/platformweb/index.html</span>
        </div>
        <div class="twodiv">
          “田田阅读”是湖北三新文化传媒有限公司与两百多家出版社合作开发的电子书数据库。提供海量正版电子书资源，总数量超过19万品种，近三年新书占比达到90%以上，且每周都在持续增加。可同步销售数几十万种电子书，其中亚马逊电子书和化工出版社专区等为独家销售。书籍类型丰富多样，提供文学小说、历史传记、经济管理、成功励志、人文社科、生活、艺术等大众读物；也包含IT互联网、基础科学、工业技术、农业科学、医学卫生等专业著作。图书格式规范统一，支持多终端同步阅读。
        </div>
      </div>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponent.vue'
  import { listclassifyTypes, searchlist } from '@/api/img'
  import { selectUnionPublisher } from '@/api/pages'
  import Cookies from 'js-cookie'
  import MyAside from '@/components/MyAside.vue'
  export default {
    name: 'ProductTiantian',
    data() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      toLogin(url){
        if(Cookies.get('passPort')){
          window.open(`${url}?passPort=${Cookies.get('passPort')}`);
        }else{
           window.open(url)
        }
      },
      // 进入直播
      ComeLive() {
        // 1、后台如果设置了默认直播，就传过去默认直播的id，否则就传0
        // 2、HomePage: true; 用来判断是不是从首页进入的，
        // 首页进来的话，优先播放和服务器时间对的上的直播，
        // 其次是查看有没有默认直播，
        // 上面都没有满足的话就展示没有直播提醒的提示
        // 3、直播页中直接点击议程跳转到新的页面，就展示点击的议程的直播 Cookies.set('linkUrl', item.linkUrl) Cookies.get('linkUrl')
        this.$router.push({ name: 'LookLiveG', params: { webinarId: 0 } })
        Cookies.set('HomePage', true)
        Cookies.set('playType', 1)
        Cookies.set('playUrl', 'null')
      }
    },
    components: {
      BottomComponent,
      TopComponent,
      [MyAside.name]: MyAside
    },
  }
</script>

<style scoped lang="scss">
  .commonLiStyle {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
  }

  /* banner */
  .bannerFirst {
    height: 67px;
    cursor: pointer;
    background: url('../../assets/images/NewBanner.png') no-repeat center center;
    background-size: auto 100%;
  }

  /* 公共 */
  .commonLiContainer {
    display: flex;
    justify-content: center;
    padding: 60px 50px;
    background-color: #FFDDB0;
  }

  .commontent {
    padding: 74px 100px 50px 100px;
    background-color: #fff;
    font-family: PingFang-SC-Bold;
  }

  /* title */
  .titleMap {
    color: #000;
    font-size: 40px;
  }

  .letterTitle {
    color: #333;
    font-size: 16px;
    margin-top: 10px;
    margin-bottom: 68px;
  }

  /* 1 */
  .twodiv {
    color: #333;
    font-size: 16px;
    margin-top: 10px;
    line-height: 25px;
    text-align: left;
    &.link{
      span{
         cursor: pointer;
         text-decoration: underline;
      }
    }
  }

  /* 2 */
  .threediv {
    margin: 20px auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/ChildPages/Product-Tiantian.vue